import strings from '../lang/strings'
import React from 'react'
import {API_URL, FORMAT} from '../config/const'

const moment = require('moment')

export const getTimeFromSecond = (seconds) => {
  let sec = seconds % 60
  let min = (seconds - sec) / 60
  let min_str = ''
  let sec_str = ''
  if (min < 10) {
    min_str = '0' + min.toString()
  } else {
    min_str = min.toString()
  }
  if (sec < 10) {
    sec_str = '0' + sec.toString()
  } else {
    sec_str = sec.toString()
  }

  return min_str + ':' + sec_str
}

export const checkEmail = (email) => {
  const preEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i
  return preEx.test(email)
}

export const formatNumber = (num) => {
  if (num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  } else {
    return num
  }
}

export const checkPwd = (pwd) => {
  const preEx = /^(?=.*).{6,15}$/i // /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#\$&*~]).{6,15}$/i
  return preEx.test(pwd)
}

export const chkNoteTitle = (txt) => {
  return txt.replace(/[^@$!%\^*#?&~\(\)-=_\+\|\{\}\[\];:'",\.\/<>\?＃＆＊＠§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡??ªº\sㄱ-ㅎ가-힣a-zA-Z0-9ㆍ ᆢ]/gi, '')
}

export const fphoto = (url, folder, def = '') => {
  if (url === null || url === '' || url === undefined) return def
  if (url.startsWith('http')) return url
  if (folder === '') return API_URL + '/uploads/' + url
  return API_URL + '/uploads/' + folder + '/' + url
}

export const string = {
  Format: function() {
    let args = arguments
    return args[0].replace(/{([0-9]+)}/g, function(s) {
      return args[+s.slice(1,-1)+1]
    })
  }
}

export const ceil = (val, n = 1) => {
  return Math.ceil(val * Math.pow(10, n)) / Math.pow(10, n)
}

export const customDateFormat = (date, line = false) => {
  if (date === '0000-00-00 00:00:00') return '-'
  const days = [strings.sun, strings.mon, strings.tue, strings.wed, strings.thr, strings.fri, strings.sat]
  return moment(date).format('YY.MM.DD') + '(' + days[moment(date).weekday()] + ') ' + (line ? '\n' : '') + moment(date).format(FORMAT.TIME2)
}

export const customDateTimeFormat = (date, line = false) => {
  if (date === '0000-00-00 00:00:00') return '-'
  const days = [strings.sun, strings.mon, strings.tue, strings.wed, strings.thr, strings.fri, strings.sat]
  return moment(date).format('YY.MM.DD') + ' ' +(line ? '\n' : '') + moment(date).format(FORMAT.TIME2)
}

export const drawTableTitleCell = (title, is_new) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='w-100'>
        {title}
      </div>
      {is_new == 1 && <img className='icon_new2' src='/assets/image/new_bk.png' alt=''/>}
    </div>
  )
}

export const drawTableArticleType = (dat_cate, is_special=false) => {
  return (
    <div className='text-center w-100 f-b'>
      {
        is_special && 
        <div>
           <span style={{background: 'RGB(233, 65, 82)', color: '#fff', padding: '2px 4px', fontWeight : '500', borderRadius: '4px' , fontSize: '11px'}}>Special</span>
        </div>
      }
      <span style={dat_cate == 4 ? {color : '#D24646'} : dat_cate == 5 ?  {color : '#0f4c81'} : ""}>
        {
          dat_cate == 4 ? strings.article_type_pm : dat_cate == 5 ? strings.article_type_eve : ""
        }
      </span>
    </div>
  )
}

export const drawTableBJPointCell = (cost, price, is_purchased, is_readable) => {
  if (price == 0 || is_purchased == 1 || is_readable == 0) {
    return null
  } else {
    return (
      <div className='text-center w-100'>
        <div className='fs-14 sm-fs-12 color-4c4c4d webkit-line-clamp-1 '>{formatNumber(price) + strings._p}</div>
      </div>
    )
  }
}

export const randomString = (length, type = 'all') => {
  let chars = ''
  switch (type) {
    case 'all':
      chars = '0123456789!@#$%^&*abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXTZ'
      break
    case 'alpha-digit':
      chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXTZ'
      break
    case 'alphabet':
      chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXTZ'
      break
    case 'digit':
      chars = '0123456789'
      break
    case 'invite':
      chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZ'
      break
    case 'recovery':
      chars = '0123456789abcdefghijklmnopqrstuvwxyz'
      break
    default:
      chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXTZ'
  }

  let randomString = ''
  for (let i = 0; i < length; i++) {
    let rnum = Math.floor(Math.random() * chars.length)
    randomString += chars.substring(rnum, rnum + 1)
  }

  return randomString
}

export const diff = (time) => {
  let val = parseInt(moment().diff(moment(time)) / 1000)
  if (val < 60) return val + strings.sec_ago
  if (val < 3600) return parseInt(val / 60) + strings.min_ago
  if (val < 86400) return parseInt(val / 3600) + strings.hour_ago
  return parseInt(val / 86400) + strings.day_ago
}

export const htmlToText = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const text = tempDiv.innerHTML
      .replace(/<br\s*\/?>/gi, '\n') // <br> 태그를 줄바꿈으로 변경
      .replace(/<\/?h[1-6]>/g, '\n') // h 태그의 시작과 끝도 줄바꿈으로 처리
      .replace(/<\/?p[^>]*>/g, '\n') // <p> 태그의 시작과 끝을 줄바꿈으로 처리
      .replace(/&nbsp;/g, ' ') // &nbsp;를 일반 공백으로 변환
      .replace(/<[^>]*>/g, '') // 나머지 HTML 태그 제거
      .replace(/\n+/g, '\n') // 연속된 줄바꿈을 하나로
      .trim(); // 양쪽 공백 제거

  return text;
}

export const getPointCellInfo = (info) => {
  if (info.is_purchased == 1) {
    return { color : null, value : strings.is_already_purchase}
  } else if (info.is_readable == 0) {
    return { color : strings.disable_buy_color, value : strings.disable_buy}
  } else if (info.is_readable == 1) {
    if (info.is_free == 1) {
      return { color : strings.no_buy_color, value : strings.free_price }
    }
    if (info.is_my_data == 1) {
      return { color : strings.no_buy_color, value : formatNumber(info.dat_po) + strings._p}
    }

    return { color : strings.no_buy_color, value : info.dat_po == 0 ?  strings.no_buy :  formatNumber(info.dat_po) + strings._p }
  }
}